import PropTypes from 'prop-types';
import React, { Component } from 'react';
import classNames from 'classnames';
import qs from 'query-string';

import Icon from 'components/Icon';
import Input from '../Input';
import { COLORS } from 'config/constants';

/**
 * [SearchInput] - Useful when generating a single search input without redux form
 * Auto handles icon and clear behavior (if onChange passed)
 * @prop {string} value
 * @prop {func} onChange
 * @prop {string} [name='search']
 * @prop {string} [placeholder='Search']
 * @prop {func} [onClear] -  if you want to do extra things when input is clear (i.e. clear search results)
 * @prop {string} [urlSearchParam]
 */

class SearchInput extends Component {
  // TODO: Handle query param checking
  componentDidMount() {
    const { urlSearchParam } = this.props;
    if (urlSearchParam) {
      const { value, onChange } = this.props;
      // Check for url query for search
      const params = qs.parse(window.location.search);
      const searchParam = params[urlSearchParam];
      // If url param doesn't match search param, then likely reloading or visiting from url.
      if (searchParam && searchParam !== value) {
        onChange({ target: { value: searchParam } });
      }
    }
  }

  render() {
    const {
      className,
      name = 'search',
      placeholder = 'Search',
      error,
      ...rest
    } = this.props;

    const inputClass = classNames('SearchInput', className);

    return (
      <Input
        autoComplete={false}
        className={inputClass}
        clearable // in case no onClear logic passed, default to clearable
        name={name}
        error={error}
        placeholder={placeholder}
        prependIcon={
          <Icon
            type={Icon.TYPES.SEARCH}
            color={error ? COLORS.DANGER : Icon.COLORS.DARK}
          />
        }
        rounded
        type="text"
        style={{ minHeight: 41 }}
        {...rest}
      />
    );
  }
}

SearchInput.propTypes = {
  className: PropTypes.string,
  name: PropTypes.string,
  onChange: PropTypes.func,
  onClear: PropTypes.func,
  placeholder: PropTypes.string,
  urlSearchParam: PropTypes.string,
  value: PropTypes.string,
  error: PropTypes.oneOfType([PropTypes.node, PropTypes.bool])
};

export default SearchInput;
